import { faEye, faEyeSlash, faPlus, faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import * as Constants from "../../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../../Helper/withoutImageHeader";
import Select from 'react-select';

const AddReportBioTwo = () => {
    const breadcrumData = ['Dashboard', 'Patient Detail'];
    const breadcrumItem = ['Add Report'];
    const options = [
        { label: 'Hematology' },
        { label: 'Biochemistry' },
        { label: 'Hormons' },
        { label: 'Urine Normal Range' },
    ]
    const list = [
        { label: 'CBC' },
        { label: 'ABG' },
        { label: 'ESR' },
        { label: 'HbA1c' },
        { label: 'BLEEDING TIME' },
        { label: 'CLOTTING TIME' },
        { label: 'Trop-T' },
        { label: 'trop-I' },
        { label: 'CALCIUM' },
    ]
    const Category = [
        { label: 'Hb' },
        { label: 'TLC' },
        { label: 'DLC' },
        { label: 'GRANULOCYTE' },
        { label: 'LYMPHOCYTS' },
        { label: 'MONOCYTES' },
        { label: 'EOSINPHILS' },
    ]
    return (
        <div className="add_Report_hemotology manage_select_react">
            <WithoutImageHeader header={Constants.ADD_REPORT}
                lefticon={'menu'}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="report_main_area">
                            <div className="inner_area">
                                <div className="dropdown_box">
                                    <h6>Test Type<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            defaultValue={options[1]}
                                            options={options}
                                        />
                                    </div>
                                </div>
                                <div className="dropdown_box">
                                    <h6>Test Name<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            options={list}
                                        />
                                    </div>
                                </div>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Test Category<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_div_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( U/L )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <a href="javscript:;">
                                                    <div className="plus_box">
                                                        <FontAwesomeIcon icon={faPlus} className="icon_plus" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Test Category<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_div_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( U/L )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <a href="javscript:;">
                                                    <div className="plus_box">
                                                        <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="dropdown_box">
                                    <h6>Test Category<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            options={Category}
                                        />
                                    </div>
                                </div>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Sub Category ( Bilirubin )<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_btns_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( mg/dl )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <div className="icons_main">
                                                    <div>
                                                        <a href="javscript:;">
                                                            <div className="plus_box">
                                                                <FontAwesomeIcon icon={faPlus} className="icon_plus" />
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <a href="javscript:;">
                                                            <div className="plus_box space_area">
                                                                <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Test Category<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_div_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( mg/dl )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <a href="javscript:;">
                                                    <div className="plus_box">
                                                        <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Test Category<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_div_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( g/dl )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <a href="javscript:;">
                                                    <div className="plus_box">
                                                        <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="add_btn_area">
                                <a href="javascript:;">+ Add Test Type</a>
                            </div>
                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default AddReportBioTwo;